module.exports = {
      id: "googleplay-en-usage",
      viewBox: "0 0 135 40",
      url: __webpack_public_path__ + "assets/img/sprite-8cafc1.svg#googleplay-en-usage",
      toString: function () {
        return this.url;
      }
    }